import { render, staticRenderFns } from "./lt.vue?vue&type=template&id=1497065c&scoped=true&"
import script from "./lt.vue?vue&type=script&lang=js&"
export * from "./lt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1497065c",
  null
  
)

export default component.exports